// Import packages
import React from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Save({ action, setOpenVariable, variables, automId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.';

    return (
        <>
            <div>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'SHEETS-TO-SAVE')} is_required />
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired multiSelect={true}/>
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.MULTIPLE-VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'FOLDER-PATH')} is_required />
                    <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
                        variables={variables} isRequired hideRequired autom_id={automId} />
                    <small className="conf-field-desc"><em>e.g.    C:\Autommate\test</em></small>
                </div>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'ASSIGN-PATH')} />
                    <VariablePicker action={action} inputName="assignToVariable" variables={variables}
                        setOpenVariable={setOpenVariable} filter="string" />
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
                </div>
            </div>
        </>
    )
}

export default Save;
